<template>
  <div></div>
</template>

<script>
export default {
  name: "MetaDataComponent",
  props: {
    title: String,
    description: String,
    keywords: String,
  },
  watch: {
    title(newTitle) {
      this.updateTitle(newTitle);
    },
    description(newDescription) {
      this.updateDescription(newDescription);
    },
    keywords(newKeywords) {
      // Watch for changes in 'keywords'
      this.updateKeywords(newKeywords);
    },
  },
  beforeMount() {
    this.updateTitle(this.title);
    this.updateDescription(this.description);
    this.updateKeywords(this.keywords);
  },
  methods: {
    updateTitle(newTitle) {
      console.log({ newTitle });
      document.title = newTitle;
    },

    updateDescription(newDescription) {
      const metaDescription = document.querySelector(
        'meta[name="description"]'
      );
      if (metaDescription) {
        metaDescription.setAttribute("content", newDescription);
      } else {
        const newMeta = document.createElement("meta");
        newMeta.setAttribute("name", "description");
        newMeta.setAttribute("content", newDescription);
        document.head.appendChild(newMeta);
      }
    },

    updateKeywords(newKeywords) {
      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute("content", newKeywords);
      } else {
        const newMeta = document.createElement("meta");
        newMeta.setAttribute("name", "keywords");
        newMeta.setAttribute("content", newKeywords);
        document.head.appendChild(newMeta);
      }
    },
  },
};
</script>

<style scoped></style>
